import { put } from "redux-saga/effects";

import type { UpdatePageSettings2Input } from "../../../gql/graphql";
import type { StopNewFeatureTourAction } from "../../tour/tourActions";
import { requestSavePageSettings } from "../pageSettingsActions";

export function* updateWelcomeTourPageSettings() {
  const input: UpdatePageSettings2Input = {
    tour: {
      introductionTourSeen: true,
    },
  };

  yield put(requestSavePageSettings(input));
}

export function* updateFeaturesSeenPageSettings(
  action: StopNewFeatureTourAction,
) {
  const input: UpdatePageSettings2Input = {
    tour: {
      featuresSeen: action.payload.seenIds,
    },
  };

  yield put(requestSavePageSettings(input));
}
